import { useTranslations } from '@/i18n/use-translations';

/** The palette's key hints — present on every state the palette can show. */
export function PaletteFooter() {
  const t = useTranslations('pages.shell.search');

  return (
    <div className="flex items-center justify-between gap-4 border-t border-border bg-canvas px-4 py-2">
      <p className="truncate text-xs text-text-tertiary">{t('footer')}</p>
    </div>
  );
}
